import { type BadgeLabel } from '../../../ui/atoms/Badge/types';

const REPORT_LABELS = {
  ONLINE: {
    translationId: 'Online_ordering' as TranslationId,
    tone: 'brand' as const,
  },
  POS: {
    translationId: 'Point_of_Sale' as TranslationId,
    tone: 'brand' as const,
  },
} satisfies Record<string, BadgeLabel>;

const DASHBOARD_LABELS: Record<string, BadgeLabel[]> = {
  Business_review_report_title: [REPORT_LABELS.ONLINE],
  Ordered_items_report: [REPORT_LABELS.ONLINE],
  Ordered_items_report_title: [REPORT_LABELS.ONLINE],
  Sales_report: [REPORT_LABELS.ONLINE],
  Sales_report_title: [REPORT_LABELS.ONLINE],
  Online_tips_report: [REPORT_LABELS.ONLINE],
  Campaign_performance_report: [REPORT_LABELS.ONLINE],
  Store_operations_report: [REPORT_LABELS.ONLINE],
  Customers_report: [REPORT_LABELS.ONLINE],
  Customer_reports: [REPORT_LABELS.ONLINE],
  Performance_summary: [REPORT_LABELS.ONLINE],
  Sales_report_beta: [REPORT_LABELS.ONLINE],
  Weekly_report: [REPORT_LABELS.ONLINE],
  Sales_summary_report: [REPORT_LABELS.ONLINE, REPORT_LABELS.POS],
  Tips_report_title: [REPORT_LABELS.ONLINE, REPORT_LABELS.POS],
  Sales_tax_report: [REPORT_LABELS.ONLINE, REPORT_LABELS.POS],
  Menu_items_report: [REPORT_LABELS.POS],
  Property_operations_report: [REPORT_LABELS.ONLINE, REPORT_LABELS.POS],
};

function getDashboardLabels(dashboardName: string): BadgeLabel[] {
  return DASHBOARD_LABELS[dashboardName] ?? [];
}

export { getDashboardLabels, REPORT_LABELS };
